import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import store from "./store";

import "./assets/tailwind.css"

import VClickOutside from "v-click-outside";
Vue.use(VClickOutside);

import PortalVue from "portal-vue";
Vue.use(PortalVue);

Vue.config.productionTip = false;

import splitbee from "@splitbee/web";
if (process.env.NODE_ENV === 'production') {
  splitbee.init({
    scriptUrl: "/bzzbzz.js",
    apiUrl: "/_hiveaction",
  });
}

new Vue({
  store,
  render: (h) => h(App),
  created() {
    if (process.env.NODE_ENV === 'production') {
      store.commit("initializeStore")
    }
  }
}).$mount("#app");
